<template>
    <div class="view-content view4">
        <div class="title">{{ $t('主要产品') }}</div>
        <div class="ul">
            <div class="li" v-for="(item, index) in list" :key="index">
                <div class="li-img-box"><img class="li-img" :src="item.img" /></div>
                <div class="view4-text">{{ item.text }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'view4',
  data () {
    return {
        list: [
            {
                img: require('./img/1030/view4-1.png'),
                text: this.$t('支持电商 RWA 的高性能公链'),
            },
            {
                img: require('./img/1030/view4-2.png'),
                text: this.$t('稳定币、DEX、去中心信用等电商基础协议'),
            },
            {
                img: require('./img/1030/view4-3.png'),
                text: this.$t('同时为WEB2和WEB3用户服务的电商APP'),
            },
            {
                img: require('./img/1030/view4-4.png'),
                text: this.$t('法币和数字货币统一支付及结算体系'),
            },
        ]
    }
  },
}
</script>

<style scoped>
@import "./css/index.css";
.view4 {
    flex-direction: column;
    justify-content: center;

}
.view4 .ul {
    padding-top: 228px;
    flex-shrink: 0;
    align-self: stretch;
}
.view4 .li {
    border: 1px solid rgba(1, 224, 19, 0.5);
    padding: 86px 20px 47px 20px;
    align-self: stretch;
}
@media screen and (max-width: 768px) {
    .view4 {
        justify-content: center;
    }
    .li-img-box {
        justify-content: flex-start;
        padding-bottom: 0;
        height: auto;
    }
    .li-img-box .li-img {
        width: 100px;
        margin-bottom: 6px;
    }
    .view4-text {
        font-size: 14px;
        font-weight: 400;
        padding: 16px 0 31px;
        text-align: left;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/lobby/components1030/view4.vue